





export default {
  name: 'geotap-logo'

  data: ->
    logo: require '@/assets/images/games/geotap-game/geotap-game-logo-lucre-games-white.png'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geotap/GeotapLogo.vue